import React, { useState } from "react";
import Loader from "../../components/loader";
import UiTable from "../../components/table/Table";

import { useDistributionsData } from "../../context/contractDataLoaderService";
import WalletConnect from "../../components/common/walletConnect/index";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../context/globalContext";

function PendingOrders(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    userCountryCode,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const { data, loading } = useDistributionsData();
  const headers = [
    // { label: "Security", val: "security" },
    // { label: "Record date", val: "recordDate" },
    // { label: "Balance", val: "balance" },
    // { label: "Earnings", val: "earnings" },
    // { label: "Next record date", val: "nextRecordDate" },
    { label: "Platform Name", val: "platformName" },
    { label: "Earnings", val: "earnings" },
  ];

  return (
    <>
      {loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="w-100">
          <h3 className="mb-3 d-flex">Distributions</h3>
          <div className="pools-table width-100">
            <UiTable
              thead={headers}
              tbodyData={data ?? []}
              hover
              provider={provider}
              web3={web3}
              account={account}
              chainId={chainId}
              bordered={false}
            />
          </div>
        </div>
      </section>
      <WalletConnect loggedIn={props.loggedIn} />
    </>
  );
}

export default function Distributions(props) {
  return <PendingOrders {...props} />;
}
